export default __webpack_public_path__ + "static/media/solar_cup-bold.e9dd0ec8.svg";